import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      Created with ♥ by <b><a  target="_blank">AnyBid</a></b> 2026
    </span>
     
  `,
})
export class FooterComponent {s
}
